import { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { HeaderTitle } from '../../../../common/HeaderTitle.jsx'
import { Checkbox } from '../../../../common/inputs/Checkbox.jsx'
import { Textarea } from '../../../../common/inputs/Textarea.jsx'
import { Select } from '../../../../common/inputs/Select.jsx'
import ButtonWithIcon from '../../../../common/ButtonWithIcon.jsx'
import { Icons } from '../../../../common/Icons.jsx'
import { useKomunikatPowitalny } from '../../../../../api/domain/komunikaty/queries/useKomunikatPowitalny.jsx'
import { useZapiszKomunikatPowitalny } from '../../../../../api/domain/komunikaty/mutations/useZapiszKomunikatPowitalny.jsx'

const ViewKomunikatEdytor = () => {
    const { data, isLoading } = useKomunikatPowitalny()
    const { mutate: zapisz, isPending } = useZapiszKomunikatPowitalny()

    const [aktywny, setAktywny] = useState(false)
    const [tresc, setTresc] = useState('')
    const [czestotliwoscDni, setCzestotliwoscDni] = useState('-1')

    useEffect(() => {
        if (data) {
            setAktywny(data.aktywny ?? false)
            setTresc(data.tresc ?? '')
            setCzestotliwoscDni(String(data.czestotliwosc_dni ?? -1))
        }
    }, [data])

    const handleZapisz = () => {
        zapisz({ aktywny, tresc, czestotliwosc_dni: Number(czestotliwoscDni) })
    }

    const opcjeCzestotliwosci = [
        { value: '-1', label: 'Przy każdym zalogowaniu' },
        { value: '0',  label: 'Raz na sesję (do zamknięcia przeglądarki)' },
        { value: '1',  label: 'Raz na dobę' },
        { value: '7',  label: 'Raz na tydzień' },
        { value: '30', label: 'Raz na miesiąc' },
    ]

    return (
        <div>
            <HeaderTitle
                breadcrumbLinks={[
                    {label: 'Komunikat powitalny'},
                ]}
                home
                destination="/oper/slowniki/lista"
                size="fs-3"
                nav
                title="Komunikat powitalny"
            />
            <Container className="d-flex flex-column gap-4" style={{ maxWidth: 800 }}>
                {isLoading ? null : (
                    <>
                        <Checkbox
                            id="komunikat-aktywny"
                            name="aktywny"
                            label="Komunikat aktywny"
                            value={aktywny}
                            onChange={(e) => setAktywny(e.target.checked)}
                        />
                        <Select
                            label="Częstotliwość wyświetlania"
                            value={czestotliwoscDni}
                            options={opcjeCzestotliwosci}
                            noEmpty
                            onChange={(e) => setCzestotliwoscDni(e.target.value)}
                        />
                        <Textarea
                            label="Treść komunikatu"
                            rows={10}
                            limit={1000}
                            value={tresc}
                            onChange={(e) => setTresc(e.target.value)}
                        />
                        <div>
                            <ButtonWithIcon
                                icon={<Icons.update />}
                                onClick={handleZapisz}
                                variant="primary"
                                text="Zapisz komunikat"
                                disabled={isPending}
                            />
                        </div>
                    </>
                )}
            </Container>
        </div>
    )
}

export default ViewKomunikatEdytor
